import { invoicePaymentDate } from './invoiceKanbanDates';
const dayKey = (date: Date) => `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
export function matchesPageMonth(value: string | null | undefined, month: string): boolean {
  if (month === 'all') return true;
  const date = invoicePaymentDate(value || '');
  return !!date && dayKey(date).slice(0,7) === month;
}
export function overlapsPageMonth(start: string | null | undefined, end: string | null | undefined, month: string): boolean {
  if (month === 'all') return true;
  const first = invoicePaymentDate(start || '');
  const last = invoicePaymentDate(end || '');
  if (!first || !last || last < first) return false;
  const [year, number] = month.split('-').map(Number);
  return first <= new Date(year, number, 0) && last >= new Date(year, number-1, 1);
}
